/**
 * Shared bits for the pop-ups that show private account details (change
 * email, change security Q&A, verify email) and the ones that need the
 * current password (those plus delete account).
 *
 * The details come from identityService.getMyAccount, which is a network
 * call. The pop-ups render right away with shimmer placeholders and fill
 * them in when the details arrive, so a slow network doesn't look frozen.
 */
import { iPop } from "../ipop_v2.js";

// A shimmer placeholder. Give it an id and replace it with fillLoadedText.
export const loadingTextHTML = (id) =>
  `<span class="courier loadingTextBlank shimmer" id="${id}"></span>`;

/**
 * Replaces a loading placeholder with text. Uses textContent, so it's safe
 * for user-entered text. Does nothing if the pop-up was closed meanwhile.
 * @param {string} id
 * @param {string} text
 * @returns {boolean} false if the element is gone
 */
export const fillLoadedText = (id, text) => {
  const element = document.getElementById(id);
  if (!element) return false;
  element.classList.remove("loadingTextBlank", "shimmer");
  element.textContent = text;
  return true;
};

// The ⓘ next to "Current Password:" labels. Each pop-up uses its own id and
// registers renderCurrentPasswordSplainer for it.
export const currentPasswordSplainerHTML = (id) =>
  `<div id="${id}" class="i">ⓘ</div>`;

export const renderCurrentPasswordSplainer = (event) => {
  iPop.render({
    text: "Your current password is required to change your email or security question, or to delete your account. That way, nobody else using this browser can make these changes.",
    event,
  });
};
